import { alpha as alphaTool, color as colorTool } from "./colorTools";
import { space as spaceTool, unit as unitTool } from "./spaceTools";
import { tombacThemeColors } from "../cjs/tombacCommons";
function parseAlpha(value) {
  const matches = value.match(new RegExp(`^--(${tombacThemeColors.join("|")})-(i?)a(8|16|24|32|40|48)`));
  if (!matches) {
    return () => value;
  }
  const color = matches[1];
  const inverted = Boolean(matches[2]);
  const alpha = matches[3] ? Number(matches[3]) : undefined;
  if (!alpha) {
    return () => value;
  }
  return alphaTool(color, alpha, {
    inverted
  });
}
function parseColor(value) {
  const matches = value.match(new RegExp(`^--(${tombacThemeColors.join("|")}|white|black)(-([1-9]00))?$`));
  if (!matches) {
    return () => value;
  }
  const color = matches[1];
  const grade = matches[3] ? Number(matches[3]) : undefined;
  switch (color) {
    case "white":
      return colorTool("neutral", 100);
    case "black":
      return colorTool("neutral", 900);
    default:
      return colorTool(color, grade);
  }
}
function parseUnit(value) {
  const matches = value.match(/^(-?\d+(\.(\d+)?)?|\.\d+)([a-z]+)?$/);
  if (!matches) {
    return () => value;
  }
  const number = Number(matches[1]);
  const unit = matches[4];
  switch (unit) {
    case "u":
      return unitTool(number);
    case "sp":
      return spaceTool(number);
    default:
      return () => value;
  }
}
export const parse = value => props => {
  return value === null || value === void 0 ? void 0 : value.split(/\s+/).map(v => {
    v = parseAlpha(v)(props);
    v = parseColor(v)(props);
    v = parseUnit(v)(props);
    return v;
  }).join(" ");
};
//# sourceMappingURL=parseTool.js.map